module.exports = __webpack_public_path__ + "img/6h.688e4bd3.png";